import React from "react";
import ModalBasic from "../../component/ModalBasic";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import TinyEceEditor from "../../../components/ckEditor/TinyMCEEditor";
import CKClassicEditor from "../../../components/ckEditor/CKClassicEditor";

const WelcomeLetter = (props) => {
    return (
        <ModalBasic
            id="send-payment-link-modal"
            modalOpen={props.clarificationModal}
            setModalOpen={props.setOpenModal}
            title="Welcome Letter Detail"
        // noCloseIcon={true}
        >
            <div className="pb-6 px-7 mt-2">
                <div>
                    <CKClassicEditor
                        key={"welcomeletter"}
                        onChange={(e) => props.onTinyEceEditorChange(e, "welcomeletter")}
                        data={props.clarification}
                    />
                </div>
                <div className="text-center">
                    {
                        props && props.isLoading === true ?
                            <ButtonLoader className="btn btn-orange mt-8" />
                            :
                            <button
                                className="btn btn-orange text-base text-[#fff] font-bold mt-8"
                                onClick={() => props.saveClarificationDetails()}
                            >
                                Update
                            </button>
                    }
                </div>
            </div >
        </ModalBasic>
    );
}
export default WelcomeLetter;